import React from "react";
import { observer } from "mobx-react";
import { DateTime } from "luxon";

import { getDisplayedAmount, ISOToDisplayCode } from "@utils";
import { BetSlipCashoutHistoryValue } from "@api-types/agency";
import { THEME_SETTINGS } from "@theme-settings";

export const CashOutHistoryValueRow = observer(
	function CashOutHistoryValueRow(props: {
		count: number;
		rowData: BetSlipCashoutHistoryValue;
	}) {
		const time = DateTime.fromISO(props.rowData.timestamp, {
			zone: "utc",
		})
			.toLocal()
			.toLocaleString(DateTime.DATETIME_SHORT);

		return (
			<tr className="table--bet__body__row">
				<td className="table--bet__body__data u-type--left">
					{props.count}
				</td>
				<td className="table--bet__body__data u-type--left">{time}</td>
				<td className="table--bet__body__data u-type--right">
					{getDisplayedAmount(
						props.rowData.cashoutValue,
						ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)
					)}
				</td>
			</tr>
		);
	}
);
